import { formatCount, type Locale } from '@wellformed/shared';
import type { MessageCatalog } from './entry';

/** The app shell: splash states, the drop-column and drop-table confirmations. */
export const app = {
  'app.starting': { en: 'Starting Wellformed…', nl: 'Wellformed wordt gestart…' },
  'app.unreachableTagline': { en: 'cannot reach the server', nl: 'kan de server niet bereiken' },
  'app.unreachableBefore': {
    en: 'The API is not answering. Start it with ',
    nl: 'De API antwoordt niet. Start hem met ',
  },
  'app.unreachableAfter': { en: ' and reload.', nl: ' en herlaad de pagina.' },
  'app.loadingCatalogue': { en: 'Loading the catalogue…', nl: 'De catalogus wordt geladen…' },
  'app.catalogueFailed': {
    en: 'Could not load the catalogue.',
    nl: 'De catalogus kon niet worden geladen.',
  },

  'app.deleteColumnTitle': {
    en: (name: string) => `Delete ${name}?`,
    nl: (name: string) => `${name} verwijderen?`,
  },
  'app.dropColumn': { en: 'Drop the column', nl: 'Kolom verwijderen' },
  'app.dropColumnBefore': { en: 'This runs ', nl: 'Dit voert ' },
  'app.dropColumnAfter': {
    en: '. The data in it is gone.',
    nl: ' uit. De gegevens erin zijn weg.',
  },
  'app.dropColumnRefuses': {
    en: 'Wellformed refuses if a formula still depends on this column.',
    nl: 'Wellformed weigert zolang een formule nog van deze kolom afhangt.',
  },
  'app.droppedThing': {
    en: (name: string) => `Dropped ${name}.`,
    nl: (name: string) => `${name} is verwijderd.`,
  },

  'app.deleteTableTitle': {
    en: (label: string) => `Delete ${label}?`,
    nl: (label: string) => `${label} verwijderen?`,
  },
  'app.dropTable': { en: 'Drop the table', nl: 'Tabel verwijderen' },
  'app.dropTableBefore': { en: 'This runs ', nl: 'Dit voert ' },
  'app.dropTableAfter': {
    en: (rows: number, locale: Locale) =>
      `. Its ${formatCount(rows, locale)} rows, its columns and its saved views go with it.`,
    nl: (rows: number, locale: Locale) =>
      ` uit. De ${formatCount(rows, locale)} rijen, de kolommen en de opgeslagen weergaven gaan mee verloren.`,
  },
  'app.dropTableRefuses': {
    en: 'Wellformed refuses while another table still links to this one, and names the columns that do.',
    nl: 'Wellformed weigert zolang een andere tabel nog naar deze verwijst, en noemt de kolommen die dat doen.',
  },
} as const satisfies MessageCatalog;
